import {
    CHECK_TOKEN
  } from '../actions/types'
  
  const initialState = {
    hasToken: 'no'
  }
  const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
      case CHECK_TOKEN:
          return {
            ...state,
           type: CHECK_TOKEN,
           hasToken: action.hasaToken 
          }  
          break;                     
      default:
        return state
    }
  }
  export default tokenReducer
  